"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildEventCalendarFields = exports.toDateTime = exports.buildGoogleMapsUrl = void 0;
const luxon_1 = require("luxon");
const dates_1 = require("../../helpers/dates");
const dates_2 = require("../../internationalization/locales/dates");
const email_templates_1 = require("../../internationalization/locales/email-templates");
const GOOGLE_CALENDAR_DT_FORMAT = "yyyyMMdd'T'HHmmss'Z'";
const buildGoogleCalendarUrl = (start, end, title, address) => {
    const dates = `${start.toUTC().toFormat(GOOGLE_CALENDAR_DT_FORMAT)}/${end.toUTC().toFormat(GOOGLE_CALENDAR_DT_FORMAT)}`;
    const params = new URLSearchParams({ action: "TEMPLATE", dates });
    if (title) {
        params.set("text", title);
    }
    if (address) {
        params.set("location", address);
    }
    return `https://www.google.com/calendar/render?${params.toString()}`;
};
const buildGoogleMapsUrl = (address) => `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
exports.buildGoogleMapsUrl = buildGoogleMapsUrl;
const toDateTime = (value) => {
    if (luxon_1.DateTime.isDateTime(value)) {
        return value;
    }
    return typeof value === "string" ? luxon_1.DateTime.fromISO(value) : luxon_1.DateTime.fromJSDate(value);
};
exports.toDateTime = toDateTime;
const normalizeLocale = (locale) => locale.toLowerCase().slice(0, 2);
const toAbbr3 = (dt, token, locale) => dt.toFormat(token, { locale }).replace(/\.$/, "").slice(0, 3).toUpperCase();
const interpolate = (template, tokens) => template.replace(/\{(\w+)\}/g, (match, key) => tokens[key] ?? match);
const buildMultiDayLabels = (start, end, dateFmt, timeFmt, locale, lang) => {
    const labels = (0, email_templates_1.getEmailLabels)(locale);
    return {
        eventDateLabel: interpolate(labels.eventMultiDayStart, {
            date: start.toFormat(dateFmt, { locale: lang }),
            time: start.toFormat(timeFmt),
        }),
        eventTimeRange: interpolate(labels.eventMultiDayEnd, {
            date: end.toFormat(dateFmt, { locale: lang }),
            time: `${end.toFormat(timeFmt)} ${end.toFormat("ZZZZ")}`,
        }),
    };
};
const buildEventCalendarFields = (input, locale) => {
    if (!input) {
        return {};
    }
    const lang = normalizeLocale(locale);
    const tz = input.timezone || "America/New_York";
    const start = (0, exports.toDateTime)(input.startUtc).setZone(tz);
    const end = (0, exports.toDateTime)(input.endUtc).setZone(tz);
    if (!start.isValid || !end.isValid) {
        return {};
    }
    const dateFmt = dates_2.EVENT_DATE_LABEL_FORMAT[lang] ?? dates_2.EVENT_DATE_LABEL_FORMAT.en;
    const timeFmt = dates_2.EVENT_TIME_FORMAT[lang] ?? dates_2.EVENT_TIME_FORMAT.en;
    const tzAbbr = start.toFormat("ZZZZ");
    const { eventDateLabel, eventTimeRange } = (0, dates_1.isMultiDayDate)(start, end)
        ? buildMultiDayLabels(start, end, dateFmt, timeFmt, locale, lang)
        : {
            eventDateLabel: start.toFormat(dateFmt, { locale: lang }),
            eventTimeRange: `${start.toFormat(timeFmt)} – ${end.toFormat(timeFmt)} ${tzAbbr}`,
        };
    const fields = {
        eventMonth: toAbbr3(start, "LLL", lang),
        eventDay: String(start.day),
        eventWeekday: toAbbr3(start, "ccc", lang),
        eventDateLabel,
        eventTimeRange,
        calendarFileUrl: buildGoogleCalendarUrl(start, end, input.title, input.address),
    };
    if (input.isPhysicalEvent !== false) {
        fields.eventAddress = input.address || "";
        if (input.address) {
            fields.eventMapLink = (0, exports.buildGoogleMapsUrl)(input.address);
        }
    }
    return fields;
};
exports.buildEventCalendarFields = buildEventCalendarFields;
